import { StringHelper } from './StringHelper';

export class ReactHelper {
  /**
   * Add a url parameter to the window history without refreshing the page. Allows back button and bookmarks to continue working
   * @param parameterName
   * @param parameterValue
   */
  static addUrlParamWithoutRefresh = (parameterName: string, parameterValue: string) => {
    const newUrl = StringHelper.addUrlParameter(window.location.href, parameterName, parameterValue, false);
    window.history.pushState({ path: newUrl }, '', newUrl);
  };
}
